import { dataService } from './data_service';

class SearchService {
  constructor() {
    this._searchTerm = '';
    this._searchColumnIndex = 0; // Most left data column
  }

  set searchTerm(term) {
    this._searchTerm = term;
  }

  applySearchToData(data) {
    return dataService.filterDataBySearchTerm(
      data,
      this._searchColumnIndex,
      this._searchTerm,
    );
  }

  clear() {
    this._searchTerm = '';
    document.getElementById('search-field').value = this._searchTerm;
  }
}

export let searchService = new SearchService();
